<template lang="pug">
  .sharing
    span Поделиться:
    .social.vk(@click="share('vk')")
    .social.fb(@click="share('fb')")
    .social.ok(@click="share('ok')")

    social-sharing(inline-template
      :url="cUrl"
      :title="title"
      :description="description"
      network-tag="a")
      .socials
        network.vk(network="vk")
        network.fb(network="facebook")
        network.ok(network="odnoklassniki")
</template>

<script>

export default {
  name: "Sharing",
  props: ['url', 'title', 'description'],
  data() {
    return {
      currentSocial: ''
    }
  },
  methods: {
    share(soc) {
      this.currentSocial = soc
      document.querySelector(`.sharing .socials .${soc}`).click();
    },
  },
  computed: {
    cUrl() {
      return this.url + '&social=' + this.currentSocial
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/scss/_functions.scss";
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";

.sharing {
  display: flex;
  align-items: center;

  span {
    margin-right: 0.8rem;
    font-size: 1.125rem;
  }

  .social {
    width: 1.75rem;
    height: 1.75rem;
    margin-right: 0.8rem;
    cursor: pointer;
    background: no-repeat center center / auto 100%;

    &.vk {
      background-image: url(../../assets/img/socials/vk_sharing.png);
    }

    &.fb {
      background-image: url(../../assets/img/socials/fb_sharing.png);
    }

    &.ok {
      background-image: url(../../assets/img/socials/ok_sharing.png);
    }
  }

  @include mobile_or_P {
    .social {
      width: 2rem;
      height: 2rem;
      margin-right: 0.7rem;
    }
  }
}
</style>
